hmi.utils.connection_box = function () {
    "use strict";

    var selector = null,
        data = null,
        hidden = true,
        dispatch = d3.dispatch('conectionClick'),
        left = false,
        rigth = false,
        top = false,
        bottom = false;


    var conectionClick = function (d) {
        d3.event.stopPropagation();
        var position = parseInt(d3.select(this).attr('connectionPosition'));
        dispatch.conectionClick({
            'connectionPosition': position,
            'linkId': d.id,
            'width': d.width,
            'height': d.height,
            'positionPipe': d.positionPipe,
            'x': d.x,
            'y': d.y,
        });
        connection_box.clean();
    }

    function connection_box() {
        if (data && (left || rigth || top || bottom) && !data.select &&
            hmi.showMode === hmi.constant.showMode.design) {
            var contentBox = d3.select(selector).node().getBBox();
            var select = d3.select(selector.parentNode).selectAll('g.conection-box').data([data]);

            var selectEnter = select.enter()
                .append('g')
                .classed('conection-box', true);

            var t = selectEnter.append('rect')
                .attr("x", contentBox.x)
                .attr("y", contentBox.y)
                .attr("width", parseInt(contentBox.width))
                .attr("height", parseInt(contentBox.height))
                .on({
                    'mouseout': function (d) {
                        d3.select('g.conection-box').remove();
                    }
                });
            var circleG = selectEnter.append('g')
                .classed('circles-conection', true);
            if (top) {
                circleG
                    .append("circle")
                    .classed("circle-conection", true)
                    .attr({
                        "r": 5,
                        'cx': (parseInt(contentBox.width) / 2) + contentBox.x,
                        'cy': contentBox.y,
                        'connectionPosition': hmi.constant.pipeCPosition.T
                    })
                    .on('click', conectionClick);
            }
            if (left) {
                circleG
                    .append("circle")
                    .classed("circle-conection", true)
                    .attr({
                        "r": 5,
                        'cx': contentBox.x,
                        'cy': (parseInt(contentBox.height) / 2) + contentBox.y,
                        'connectionPosition': hmi.constant.pipeCPosition.L
                    })
                    .on('click', conectionClick);
            }

            if (rigth) {
                circleG
                    .append("circle")
                    .classed("circle-conection", true)
                    .attr({
                        "r": 5,
                        'cx': parseInt(contentBox.width) + contentBox.x,
                        'cy': (parseInt(contentBox.height) / 2) + contentBox.y,
                        'connectionPosition': hmi.constant.pipeCPosition.R
                    })
                    .on('click', conectionClick);
            }
            if (bottom) {
                circleG
                    .append("circle")
                    .classed("circle-conection", true)
                    .attr({
                        "r": 5,
                        'cx': (parseInt(contentBox.width) / 2) + contentBox.x,
                        'cy': parseInt(contentBox.height) + contentBox.y,
                        'connectionPosition': hmi.constant.pipeCPosition.B
                    })
                    .on('click', conectionClick);
            }
        } else {
            d3.select('g.conection-box').remove();
        }
    }

    connection_box.dispatch = dispatch;
    connection_box.options = hmi.utils.optionsFunc.bind(connection_box);

    connection_box._calls = new function () {
        this.clean = function () {
            if (data) {
                data.select = false;
            }
            data = null;
            connection_box();
        }
    }

    connection_box._options = Object.create({}, {
        // simple read/write options
        data: {
            get: function () {
                return data;
            },
            set: function (_) {
                data = _;
            }
        },
        left: { get: function () { return left }, set: function (_) { left = _ } },
        rigth: { get: function () { return rigth }, set: function (_) { rigth = _ } },
        top: { get: function () { return top }, set: function (_) { top = _ } },
        bottom: { get: function () { return bottom }, set: function (_) { bottom = _ } },
        selector: {
            get: function () {
                return selector;
            },
            set: function (_) {
                selector = _;
            }
        },
        hidden: {
            get: function () {
                return hidden;
            },
            set: function (_) {
                hidden = _;
                if (!hidden) {
                    connection_box();
                }
            }
        },
    });

    hmi.utils.initOptions(connection_box);

    return connection_box;

};